/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
// misc imports
import { PaymentCardBrandType } from "@/interfaces/PaymentIntent.interface";
import {CARD_BRANDS} from '@/constants'

const baseClassName = "card";

export const PaymentCardBrand = ({ brand }: { brand: PaymentCardBrandType | null }) => {
  if(!brand) {
    return "";
  }
  // Assuming status represents the card brand
  const brandIcon = CARD_BRANDS[brand].icon;

  return (
    <img
      src={brandIcon}
      width={32}
      style={{verticalAlign: "middle", marginRight: "10px"}}
      alt={brand} // You may want to provide a meaningful alt text
      className={`${baseClassName}-icon`}
    />
  );
};
